import { ReactComponent as Interest } from "../../../images/interest.svg";
import { ReactComponent as Amount } from "../../../images/amount.svg";
import { ReactComponent as Fee } from "../../../images/fee.svg";
import { ReactComponent as FloorAmount } from "../../../images/floor_amount.svg";
import { ReactComponent as Redemption } from "../../../images/redemption.svg";
import { FormatCurrency } from "../../../common/Constants";

const OngoingDetails = (props) => {
  const { OverallSummary } = props;
  return (
    <div className="flooring-details-section case-issued ongoing-block">
      <h2>Overall Summary</h2>
      <div className="flooring-details-block">
        <div className="flooring-details-list">
          <div className="flooring-details-infoCard">
            <div className="details-infoCard-icon floor-amount-block">
              <FloorAmount />
            </div>
            <div className="details-card-info">
              <h3>Floor Amount</h3>
              <h4>${FormatCurrency(OverallSummary?.total_floor_amount)}</h4>
            </div>
          </div>
        </div>
        <div className="flooring-details-list">
          <div className="flooring-details-infoCard">
            <div className="details-infoCard-icon admin-fee-block">
              <Fee />
            </div>
            <div className="details-card-info">
              <h3>Admin Fee</h3>
              <h4>${FormatCurrency(OverallSummary?.total_admin_fee)}</h4>
            </div>
          </div>
        </div>
        <div className="flooring-details-list">
          <div className="flooring-details-infoCard">
            <div className="details-infoCard-icon total-interest-block">
              <Interest />
            </div>
            <div className="details-card-info">
              <h3>Total Interest Till Date</h3>
              <h4>${FormatCurrency(OverallSummary?.total_interest_till_date)}</h4>
            </div>
          </div>
        </div>

        <div className="flooring-details-list">
          <div className="flooring-details-infoCard">
            <div className="details-infoCard-icon total-amount-block">
              <Amount />
            </div>
            <div className="details-card-info">
              <h3>Total Amout Paid</h3>
              <h4>${FormatCurrency(OverallSummary?.total_amount_paid)}</h4>
            </div>
          </div>
        </div>
        <div className="flooring-details-list">
          <div className="flooring-details-infoCard">
            <div className="details-infoCard-icon redemption-block">
              <Redemption />
            </div>
            <div className="details-card-info">
              <h3>Redemption Amount</h3>
              <h4>${FormatCurrency(OverallSummary?.total_redemption_amount)}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OngoingDetails;
